import React, { useEffect, useState, useRef } from 'react';
import { Box, Typography, IconButton } from '@material-ui/core';
import CustomModal from '../../eir-porting/CustomModal/CustomModal';
import copyIcon from '../images/copyIcon.png';
import useStyles from './style';
import { publish } from 'pubsub-js';
import { useApolloClient } from '@apollo/client';
import { getQRCode } from './simReplacement.util';
import Loading from '../../../components/loading/Loading';
import MyEirErrorHandle from '../../eir-porting/MyEirErrorHandle';
import { ESIM_STATUS } from '../../../components/myeirconstant/myEirConstant';

const ESIMActivationModal = ({
    serviceId,
    openActivationModal,
    setOpenActivationModal,
    linkName,
    header,
    setCloseModal,
    setcloseOrderReplaceSimModal,
}) => {
    const classes = useStyles();
    const containerRef = useRef(null);
    const graphql = useApolloClient();
    const [open, setOpenModal] = useState(false);
    const [qrData, setQrData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [openError, setOpenError] = useState(false);
    let shouldStopRetries = false;
    const backArrowAction = () => {
        shouldStopRetries = true;
        if (linkName !== 'QR code & passcode') {
            let subscriptionId = JSON.parse(sessionStorage.getItem('LoggedinServices')).filter(
                item => item?.id === serviceId
            )[0]?.subscriptionId;
            console.log('subscriptionId', subscriptionId);
            sessionStorage.setItem('eSIM_Activation_InProgress', subscriptionId);
            publish('RELOAD_SIMREPLACEMENT');
            publish('RELOAD_SERVICE_CONTAINER');
        }
        setOpenModal(!open);
        setCloseModal(!open);
        setcloseOrderReplaceSimModal(!open);
        setOpenActivationModal(false);
    };
    const [cta1, setCTA1] = useState({ text: '', action: () => {}, disable: false });
    const [cta2, setCTA2] = useState({ text: '', action: () => {}, disable: false });
    const handleOpen = () => {
        setOpenModal(true);
    };
    //     // 🔁 Mock Data
    // const qrCodeUrl = 'iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6AQAAAACgl2eQAAAAy0lEQVR4Xu2QwQ3DMAwDtbk0WjZTTTKO0QDtAtQ5cCzyXor+zxXv5MUIYgQxghhBeAkVJCuyK/dkKHAotBD2ZCgU1nQOJ2ehtSp3Yd1nchTO/T2ZCUGydO7JT3goxQcvAavJ1poaH5fmJ6zk9AEbgZ+wG4SFkpef0MjuGA3fLLwE5hHIWMDkZCZsCulS8KdpJmBLXBQbPYWZwJk36tyJn7DyRKhNpbmACoMkYwFKqRJuwqPd4s7MBBSo+KFT7Sb8ZgQxghhBjCBGENcH8Iv7hMnShfIAAAAASUVORK5CYII=';
    // const passcode = '123456';
    // const qrCodeFormat ='png';
    // const qrcodeSrc=`data:image/${qrCodeFormat};base64,${qrCodeUrl}`;

    const handleCopy = () => {
        navigator.clipboard.writeText(passcode);
    };

    const getQRCodeResponseUtil = async () => {
        const retryDelay = 3000; // 3 seconds
        const checkQRCode = async () => {
            if (shouldStopRetries) {
                return;
            }
            const response = await getQRCode({ graphql, serviceId });
            setQrData(response);
            if (response?.activationQrCode !== '' && response?.activationQrCode != null) {
                if (linkName !== 'QR code & passcode') {
                    const isValidStatus = ![...ESIM_STATUS, null].includes(
                        response?.esimStatus?.toUpperCase() ?? null
                    );

                    if (isValidStatus) {
                        setLoading(false);
                        return;
                    }

                    setLoading(true);
                    setTimeout(checkQRCode, retryDelay);
                } else {
                    setLoading(false);
                    return;
                }
            } else if (response?.activationQrCode === '' || response?.activationQrCode === null) {
                setLoading(true);
            } else {
                if (
                    response?.errors?.graphQLErrors[0]?.extensions?.code === 'esim-data-not-found'
                ) {
                    setLoading(true);
                    setTimeout(checkQRCode, retryDelay);
                } else {
                    setOpenError(true);
                    setLoading(false);
                    setOpenModal(false);
                }
            }
        };

        checkQRCode();
    };
    useEffect(() => {
        openActivationModal && handleOpen();
    }, [openActivationModal]);

    useEffect(() => {
        if (open) {
            getQRCodeResponseUtil();
        }
    }, [open]);
    const qrCodeUrl = qrData?.activationQrCode;
    const passcode = qrData?.esimPassCode;
    const qrCodeFormat = qrData?.activationQrCodeFormat;
    const qrcodeSrc = `data:image/${qrCodeFormat};base64,${qrCodeUrl}`;
    useEffect(() => {
        // if (containerRef.current) {
        //     containerRef.current.focus();
        // }
    }, []);

    return (
        <Box id='sim-replacement' tabIndex={-1} ref={containerRef}>
            {!openActivationModal && (
                <Typography
                    component='a'
                    onClick={handleOpen}
                    className={
                        linkName === 'QR code & passcode'
                            ? classes.esimInfoLink
                            : classes.esimNewInfoLink
                    }
                    aria-label={
                        linkName === 'QR code & passcode'
                            ? 'View details of your eSIM (Scan QR code and get passcode)'
                            : 'Activate eSIM by scanning the QR code and using the passcode'
                    }
                    href='#'
                    role='link'
                    tabIndex={0}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === '') {
                            e.preventDefault();

                            handleOpen();
                        }
                    }}
                >
                    {linkName}
                </Typography>
            )}
            <CustomModal
                open={open}
                toggle={backArrowAction}
                header={{
                    text: header,
                    arrowAction: backArrowAction,
                    center: false,
                    ariaLabel: 'Go to previous page',
                }}
                description="Scan this QR code from within your device settings. If you're
                                    viewing this on the phone where you want to install the eSIM,
                                    open the eir app on another device to scan it."
                cta1={cta1}
                cta2={cta2}
                ariaLabel='eSim Activation opens popup'
            >
                <Box aria-live='polite'>
                    {loading ? (
                        <span className='loadingPosition'>
                            <Loading />
                        </span>
                    ) : (
                        <Box className={classes.esimActivationContent}>
                            <ol className={classes.stepList}>
                                <li>
                                    <Typography
                                        variant='body2'
                                        component='p'
                                        className={classes.esimActivationInstruction}
                                    >
                                        Scan this QR code from within your device settings. If
                                        you're viewing this on the phone where you want to install
                                        the eSIM, open the eir app on another device to scan it.
                                    </Typography>
                                </li>
                            </ol>
                            <Box className={classes.QrCodeContainer}>
                                <img
                                    src={qrcodeSrc}
                                    alt='QR code for activating eSIM'
                                    className={classes.esimActivationQrImage}
                                />
                            </Box>
                            <Typography
                                variant='body2'
                                component='a'
                                href={qrcodeSrc}
                                download
                                target='_blank'
                                rel='noopener noreferrer'
                                aria-label='Download QR Code to your device'
                                role='link'
                                className={classes.esimActivationDownloadLink}
                            >
                                Download QR code
                            </Typography>
                            <ol start={2} className={classes.stepList}>
                                <li>
                                    <Typography
                                        variant='body2'
                                        className={classes.esimActivationInstruction}
                                        component='p'
                                    >
                                        Copy this passcode below, you’ll need it during your eSIM
                                        installation.
                                    </Typography>
                                </li>
                            </ol>

                            <Box className={classes.passcodeBox}>
                                <Typography variant='h6' className={classes.passcodeText}>
                                    {passcode}
                                </Typography>
                                <IconButton
                                    onClick={handleCopy}
                                    aria-label='Copy passcode'
                                    role='button'
                                    tabIndex={0}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === '') {
                                            e.preventDefault();

                                            handleCopy();
                                        }
                                    }}
                                >
                                    <Box
                                        component='img'
                                        src={copyIcon}
                                        className={classes.copyIcon}
                                        alt=''
                                    />
                                </IconButton>
                            </Box>
                            <ol start={3} className={classes.stepList}>
                                <li>
                                    <Typography
                                        variant='body2'
                                        className={classes.esimActivationInstruction}
                                    >
                                        Follow the on-screen instructions on your device to complete
                                        the eSIM installation.
                                    </Typography>
                                </li>
                            </ol>
                        </Box>
                    )}
                </Box>
            </CustomModal>
            {openError ? <MyEirErrorHandle open={openError} setOpen={setOpenError} /> : ''}
        </Box>
    );
};
export default ESIMActivationModal;
